import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const ThreeSimpleCardsBase = styled.div`
  margin: 0 auto ${theme.sliceSpacing};
  padding: 0 ${theme.gutter};
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  ${theme.largerThan.lg} {
    flex-direction: row;
  }
`;

export const Title = styled.h2`
  text-align: center;
  margin: 0 0 36px 0;
`;
